import React from "react";
import { languages } from "../../constants/languages";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
// import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import TimerIcon from "@material-ui/icons/Timer";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Tooltip } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/HelpOutline";

const styles = (theme) => ({
  buttonSchedule: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
});

const TimeSliders = (props) => {
  let defaultExpandedRoot = false;
  props.divisions.forEach((division) => {
    let divisionMatchDuration = props.customMatchDuration[division.id];
    if (divisionMatchDuration === undefined) {
      divisionMatchDuration = "";
    }
    if (divisionMatchDuration !== "") {
      defaultExpandedRoot = true;
    }
    if (defaultExpandedRoot === false) {
      props.structureElements
        .filter((e) => e.division === division.id)
        .forEach((element) => {
          let elementDuration = props.customMatchDuration[element.id] || "";
          if (elementDuration !== "") {
            defaultExpandedRoot = true;
          }
        });
    }
  });
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div>
        <IconButton
          onClick={props.handleLock}
          style={{ height: 28, width: 28, marginRight: 8 }}
        >
          {props.tournament.scheduleLocked ? (
            <LockIcon
              style={{ height: 20, width: 20, position: "absolute", top: 4 }}
            />
          ) : (
            <LockOpenIcon
              style={{ height: 20, width: 20, position: "absolute", top: 4 }}
            />
          )}
        </IconButton>
      </div>

      <Button
        size="small"
        variant="outlined"
        color="default"
        onClick={props.handleMatchDurationOpen}
        disabled={props.tournament.scheduleLocked || false}
        className={props.classes.buttonSchedule}
      >
        {languages.schedule.matchDuration}
        <TimerIcon style={{ height: 16, width: 16, marginLeft: 3 }} />
      </Button>
      <div className={props.classes.iconButton} style={{ padding: 2 }}>
        <IconButton
          onClick={props.handleMatchDurationOpen}
          style={{ height: 28, width: 28 }}
          disabled={props.tournament.scheduleLocked || false}
        >
          <TimerIcon
            style={{ height: 20, width: 20, position: "absolute", top: 4 }}
          />
        </IconButton>
      </div>

      <Dialog
        open={props.matchDurationOpen}
        onClose={props.handleMatchDurationOpen}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.schedule.matchDuration}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 550, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <ExpansionPanel defaultExpanded={defaultExpandedRoot}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <div>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: "bold",
                      marginBottom: 3,
                    }}
                  >
                    {languages.schedule.allMatches}
                    <Tooltip
                      title={languages.schedule.matchDurationDescription}
                    >
                      <HelpIcon
                        style={{
                          height: 15,
                          width: 15,
                          marginLeft: 5,
                          position: "relative",
                          top: 2,
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div style={{ fontSize: 13, color: "gray" }}>
                    {languages.schedule.matchDuration}
                  </div>
                  <div>
                    <TextField
                      style={{
                        width: "100%",
                        marginBottom: 10,
                        marginRight: 10,
                      }}
                      id="matchDuration"
                      name="matchDuration"
                      value={props.matchDuration}
                      onChange={props.handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {languages.schedule.minutes}
                          </InputAdornment>
                        ),
                      }}
                      onClick={(event) => event.stopPropagation()}
                      onFocus={(event) => event.stopPropagation()}
                    />
                  </div>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                {props.divisions.length > 1 ? (
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: "bold",
                        marginBottom: 3,
                      }}
                    >
                      {languages.schedule.perDivision}
                    </div>
                    {props.divisions.map((division) => {
                      let divisionMatchDuration =
                        props.customMatchDuration[division.id];
                      let defaultExpandedDivision = false;
                      if (divisionMatchDuration === undefined) {
                        divisionMatchDuration = "";
                      }
                      props.structureElements
                        .filter((e) => e.division === division.id)
                        .forEach((element) => {
                          let elementDuration =
                            props.customMatchDuration[element.id] || "";
                          if (elementDuration !== "") {
                            defaultExpandedDivision = true;
                          }
                        });

                      return (
                        <ExpansionPanel
                          key={division.id}
                          style={{ width: "100%" }}
                          defaultExpanded={defaultExpandedDivision}
                        >
                          <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                          >
                            <div>
                              <div style={{ fontSize: 13, color: "gray" }}>
                                {division.name}
                              </div>
                              <div>
                                <TextField
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  id={"matchDuration" + division.id}
                                  name="matchDuration"
                                  value={divisionMatchDuration}
                                  onChange={(e) => {
                                    props.handleCustomMatchDurationChange(
                                      e,
                                      division.id
                                    );
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        {languages.schedule.minutes}
                                      </InputAdornment>
                                    ),
                                  }}
                                  onClick={(event) => event.stopPropagation()}
                                  onFocus={(event) => event.stopPropagation()}
                                  placeholder={props.matchDuration.toString()}
                                />
                              </div>
                            </div>
                          </ExpansionPanelSummary>
                          <ExpansionPanelDetails>
                            <div>
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: "bold",
                                  marginBottom: 3,
                                }}
                              >
                                {languages.schedule.perPouleBracket}
                              </div>
                              {props.structureElements
                                .filter((e) => e.division === division.id)
                                .map((element, i) => {
                                  return (
                                    <div key={i}>
                                      <div
                                        style={{ fontSize: 13, color: "gray" }}
                                      >
                                        {element.name}
                                      </div>
                                      <div>
                                        <TextField
                                          style={{
                                            width: "100%",
                                            marginBottom: 10,
                                            marginRight: 10,
                                          }}
                                          id={"matchDuration" + element.id}
                                          name="matchDuration"
                                          value={
                                            props.customMatchDuration[
                                              element.id
                                            ] || ""
                                          }
                                          onChange={(e) => {
                                            props.handleCustomMatchDurationChange(
                                              e,
                                              element.id
                                            );
                                          }}
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                {languages.schedule.minutes}
                                              </InputAdornment>
                                            ),
                                          }}
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                          onFocus={(event) =>
                                            event.stopPropagation()
                                          }
                                          placeholder={
                                            divisionMatchDuration
                                              ? divisionMatchDuration.toString()
                                              : props.matchDuration.toString()
                                          }
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </ExpansionPanelDetails>
                        </ExpansionPanel>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: "bold",
                        marginBottom: 3,
                      }}
                    >
                      {languages.schedule.perPouleBracket}
                    </div>
                    {props.structureElements.map((element, i) => {
                      return (
                        <div key={i}>
                          <div style={{ fontSize: 13, color: "gray" }}>
                            {element.name}
                          </div>
                          <div>
                            <TextField
                              style={{
                                width: "100%",
                                marginBottom: 10,
                                marginRight: 10,
                              }}
                              id={"matchDuration" + element.id}
                              name="matchDuration"
                              value={
                                props.customMatchDuration[element.id] || ""
                              }
                              onChange={(e) => {
                                props.handleCustomMatchDurationChange(
                                  e,
                                  element.id
                                );
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    {languages.schedule.minutes}
                                  </InputAdornment>
                                ),
                              }}
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                              placeholder={props.matchDuration.toString()}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <TextField
              style={{
                width: "100%",
                marginBottom: 10,
                marginRight: 10,
                marginTop: 20,
              }}
              id="timeBetweenMatches"
              type="number"
              name="timeBetweenMatches"
              value={props.timeBetweenMatches}
              onChange={props.handleChange}
              label={
                <>
                  {languages.schedule.timeBetweenMatches}
                  <Tooltip title={languages.schedule.timeBetweenMatchesTooltip}>
                    <HelpIcon
                      style={{
                        height: 15,
                        width: 15,
                        marginLeft: 5,
                        position: "relative",
                        top: 2,
                      }}
                    />
                  </Tooltip>
                </>
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {languages.schedule.minutes}
                  </InputAdornment>
                ),
              }}
            />
            {(props.errorMessage || "").length > 0 && (
              <DialogContentText style={{ color: "red" }}>
                {props.errorMessage}
              </DialogContentText>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={props.handleMatchDurationOpen} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={props.handleSubmitMatchDuration}
              variant="contained"
              color="primary"
              type="submit"
              disabled={props.calculating}
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

TimeSliders.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TimeSliders);
